import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
const axios = require('axios');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  i18n,

  async created() {
    axios.get(`${process.env.VUE_APP_API}/reload`);
    const credentials = JSON.parse(localStorage.getItem('API_CREDENTIALS'));
    if (credentials) {
      await axios.get(`${process.env.VUE_APP_API}/auth/verify`, {
        headers: {
          Authorization: `Bearer ${credentials.auth.access_token}`
        }
      }).catch(err => {
        //localStorage.removeItem('API_CREDENTIALS');
      })
    }
  }
}).$mount('#app')
